<template>
  <div id="list-wrap">
    <div class="item-list">
      <input
        type="text"
        class="item"
        v-for="(item, index) in items"
        :key="index"
        v-model="item.text"
        @blur="updateItem(index)"
      />
      <input type="text" class="new-item" v-model="newItem" @keyup.enter="addItem" @blur="addItem" />
    </div>
  </div>
</template>

<script>
export default {
  name: "SimpleList",
  props: ["items"],
  data() {
    return {
      newItem: "",
      currentId: 0
    };
  },
  methods: {
    updateItem: function(index) {
      if (this.items[index].text.length === 0) {
        this.items.splice(index, 1);
      }
      this.emitChange();
    },
    addItem: function() {
      if (this.newItem) {
        this.items.push({ text: this.newItem });
        this.newItem = "";
      }
      this.emitChange();
    },
    emitChange: function() {
      this.$emit("change");
    }
  }
};
</script>
<style lang="css">
#list-wrap {
}

.item-list {
  display: flex;
  flex-direction: column;
}

.item-list input {
  text-align: center;
  padding: 0.5em;
  margin: 0.2em;
}

.item {
  border: none;
  border-bottom: 1px solid #2c3e50;
}

.item:focus {
  border: 1px solid #2c3e50;
  border-radius: 3px;
}

.new-item {
  border: 1px solid #2c3e50;
  border-radius: 3px;
}
</style>